import React from 'react';
import Footer from '../components/Footer';
import Header from '../components/Header';
import { useBrand } from '../components/BrandProvider';

const GarantiePage = () => {
  const brand = useBrand();
  
  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      <Header />

      {/* Main Content */}
      <main className="flex-grow">
        <div className="max-w-4xl mx-auto px-4 py-12">
          <div className="bg-white rounded-lg shadow-md p-8 md:p-12">
            <h1 className="text-3xl md:text-4xl font-bold text-brand mb-2 text-center">
              GARANTIE
            </h1>
            <p className="text-center text-xl text-gray-600 mb-2">
              {brand.name.toUpperCase()}
            </p>
            <p className="text-center text-sm text-gray-500 mb-8">
              Dernière mise à jour : 3 novembre 2025
            </p>

            <div className="space-y-8 text-gray-700 leading-relaxed">
              {/* Section 1 */}
              <section>
                <h2 className="text-2xl font-bold text-brand mb-3">1. CADRE LÉGAL</h2>
                <p className="mb-2">
                  Le Client bénéficie des garanties légales de conformité (articles L217-3 et suivants du Code de la consommation) et contre les vices cachés (articles 1641 et suivants du Code civil).
                </p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li><strong>Garantie légale de conformité :</strong> 2 ans à compter de la délivrance du bien (réparation ou remplacement ; à défaut, réduction du prix ou résolution lorsque les conditions légales sont réunies).</li>
                  <li><strong>Garantie contre les vices cachés :</strong> selon les délais légaux à compter de la découverte du vice (article 1644 du Code civil).</li>
                </ul>
                <p className="mt-2">
                  Ces garanties s'appliquent indépendamment des garanties commerciales ci-dessous.
                </p>
              </section>

              {/* Section 2 */}
              <section>
                <h2 className="text-2xl font-bold text-brand mb-3">2. PORTÉE DE LA GARANTIE COMMERCIALE</h2>
                <p className="mb-2">
                  Certaines toiles/tissus bénéficient d'une <strong>garantie fabricant</strong> (tenue des coloris, imputrescibilité, etc.). Sauf indication contraire du fabricant, la garantie porte sur la toile elle-même (remplacement/fourniture d'une toile équivalente), <strong>hors</strong> main-d'œuvre de dépose/pose, consommables et déplacements.
                </p>
                <p>
                  Avant tout retour, <strong>contacter</strong> le service client : {brand.contact.email} (référence de commande, facture, photos/vidéos du défaut, description précise).
                </p>
              </section>

              {/* Section 3 */}
              <section>
                <h2 className="text-2xl font-bold text-brand mb-3">3. EXCLUSIONS (NON COUVERTES)</h2>
                <p className="mb-2">Ne sont pas couverts :</p>
                <ul className="list-disc list-inside space-y-1 ml-4">
                  <li>erreur de prise de mesure par le Client ;</li>
                  <li>pose non conforme / installation inadaptée ;</li>
                  <li>usure normale ;</li>
                  <li>usage anormal (ex. store laissé ouvert par vent fort) ;</li>
                  <li>défaut d'entretien (ou produits inadaptés/haute pression) ;</li>
                  <li><strong>intempéries de toute nature</strong> (vents violents, tempêtes, grêle, neige, gel, sable, atmosphère corrosive, pollution) ;</li>
                  <li>chocs, arrachements, brûlures, vandalisme, accrochage d'objets ;</li>
                  <li>salissures animales, moisissures d'origine externe (dépôts organiques) ;</li>
                  <li>variations colorimétriques progressives liées aux UV et au vieillissement normal.</li>
                </ul>
              </section>

              {/* Section 4 */}
              <section>
                <h2 className="text-2xl font-bold text-brand mb-3">4. GARANTIES FABRICANTS – TOILES ET TISSUS (RÉSUMÉ)</h2>
                <p className="mb-4">
                  Durées à compter de la date d'achat figurant sur la facture, sous réserve du respect des notices d'usage/entretien. La <strong>tenue des couleurs</strong> s'entend classiquement à <strong>4/5</strong> mini selon <strong>NF EN ISO 105-B04</strong> (sauf mention spécifique du fabricant).
                </p>

                <div className="space-y-4">
                  <div>
                    <h3 className="text-lg font-semibold text-gray-800 mb-1">4.1 S&P™ (collections S&P BEST SELLERS™ & S&P CHRONOS™)</h3>
                    <p>– <strong>12 ans</strong> : imputrescibilité et tenue des coloris (NF EN ISO 105-B04 ≥ 4/5).</p>
                  </div>

                  <div>
                    <h3 className="text-lg font-semibold text-gray-800 mb-1">4.2 LATIM</h3>
                    <p>– <strong>5 ans</strong> : imputrescibilité et tenue des coloris (NF EN ISO 105-B04 ≥ 4/5) sur les collections indiquées (BEST SELLERS™ & CHRONOS™).</p>
                  </div>

                  <div>
                    <h3 className="text-lg font-semibold text-gray-800 mb-1">4.3 SAULEDA (MASACRIL™)</h3>
                    <p>– <strong>10 ans</strong> : imputrescibilité et tenue des coloris (NF EN ISO 105-B04 ≥ 4/5).</p>
                  </div>

                  <div>
                    <h3 className="text-lg font-semibold text-gray-800 mb-1">4.4 CITEL SLU (DOCRIL™)</h3>
                    <p>– <strong>10 ans</strong> : imputrescibilité et tenue des coloris (NF EN ISO 105-B04 ≥ 4/5).</p>
                  </div>

                  <div>
                    <h3 className="text-lg font-semibold text-gray-800 mb-1">4.5 Serge Ferrari (gamme SOLTIS™)</h3>
                    <p>– <strong>5 ans</strong> : imputrescibilité et tenue des coloris (NF EN ISO 105-B04 ≥ 4/5).</p>
                  </div>

                  <div>
                    <h3 className="text-lg font-semibold text-gray-800 mb-1">4.6 Dickson Constant (ORCHESTRA, INFINITY, ORCHESTRA MAX, OPERA, SPARK, EVASION)</h3>
                    <p>– <strong>10 ans</strong> : ORCHESTRA, INFINITY, ORCHESTRA MAX, OPERA.</p>
                    <p>– <strong>5 ans</strong> : SPARK, EVASION.</p>
                    <p>– Objet : imputrescibilité et tenue des coloris (NF EN ISO 105-B04 ≥ 4/5).</p>
                  </div>

                  <div>
                    <h3 className="text-lg font-semibold text-gray-800 mb-1">4.7 SATTLER / SUN-TEX</h3>
                    <p>– <strong>5 ans</strong> à compter de la facturation, pour les qualités acryliques teintées masse et fibres CBA mentionnées par le fabricant.</p>
                    <p>– Conformité aux fiches techniques, solidité des teintures, résistance UV/intempéries (ISO 105-B04, 4-5 échelle de gris), imputrescibilité, selon conditions Sattler SUN-TEX.</p>
                  </div>
                </div>

                <p className="mt-4 text-sm italic">
                  (En cas de divergence, <strong>la garantie fabricant en vigueur à la date d'achat</strong> et/ou la mention figurant sur la facture prévaut. Les garanties commerciales n'affectent pas les droits légaux du consommateur.)
                </p>
              </section>

              {/* Section 5 */}
              <section>
                <h2 className="text-2xl font-bold text-brand mb-3">5. GARANTIE DE CONFECTION – {brand.name.toUpperCase()}</h2>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li><strong>Confection (coutures, ourlets, assemblages, accessoires de confection)</strong> : <strong>2 ans</strong>, hors usure normale.</li>
                  <li><strong>Marquage / flocage de lambrequins</strong> : <strong>2 ans</strong> (adhérence/tenue, hors abrasion, chocs, solvants).</li>
                  <li><strong>Lambrequins lumineux</strong> : <strong>2 ans</strong> sur la confection et l'intégration ; composants électriques/LED/alimentation selon la garantie du fabricant composant (au minimum 2 ans).</li>
                </ul>
                <p className="mt-2">
                  Sont exclus : surtensions, installation non conforme, non-respect d'étanchéité/indice de protection, environnement non adapté.
                </p>
              </section>

              {/* Section 6 */}
              <section>
                <h2 className="text-2xl font-bold text-brand mb-3">6. MISE EN ŒUVRE – PROCÉDURE</h2>
                <p className="mb-2">
                  Avant tout envoi : ouverture de dossier à {brand.contact.email}.
                </p>
                <p className="mb-2">
                  <strong>Fournir :</strong> facture, n° de commande, description du défaut, photos/vidéos (vue d'ensemble + gros plans), référence tissu/couleur/dimensions et configuration.
                </p>
                <p className="mb-2">
                  <strong>Après analyse :</strong> proposition de réparation/remplacement, ou orientation vers le fabricant pour expertise ; modalités logistiques communiquées (adresse d'envoi, prise en charge des frais selon le cas).
                </p>
                <p>
                  Tout retour non autorisé peut être refusé.
                </p>
              </section>

              {/* Section 7 */}
              <section>
                <h2 className="text-2xl font-bold text-brand mb-3">7. ENTRETIEN – BONNES PRATIQUES (CONDITIONNENT LA GARANTIE)</h2>
                <ul className="list-disc list-inside space-y-1 ml-4">
                  <li>Replier le store en cas de vent fort/rafales, orages, grêle/neige.</li>
                  <li>Nettoyer régulièrement à l'eau claire et brosse souple ; proscrire solvants/détergents agressifs et nettoyeur haute pression.</li>
                  <li>Éviter les poches d'eau (laisser sécher déployé après pluie si possible).</li>
                  <li>Ne pas accrocher d'objets à la toile ; ne pas marcher sur la toile.</li>
                  <li>Respecter les notices spécifiques de chaque fabricant (fréquence d'entretien, produits recommandés).</li>
                </ul>
              </section>

              {/* Section 8 */}
              <section>
                <h2 className="text-2xl font-bold text-brand mb-3">8. TOLÉRANCES, ASPECTS INHÉRENTS ET LIMITES</h2>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li><strong>Tolérances dimensionnelles</strong> : une variation jusqu'à <strong>± 1 %</strong> de la largeur/projection (avec un minimum de <strong>± 10 mm</strong>) n'est pas considérée comme un défaut.</li>
                  <li><strong>Ondulations naturelles</strong> (« smile effect ») au voisinage des coutures/ourlets/lais, marbrures légères, effets de banding et tensions locales liés au roulage et à la structure textile sont inhérents au produit et <strong>n'ouvrent pas droit à garantie</strong>.</li>
                  <li><strong>Variations de teinte</strong> : de légers écarts entre bains de teinture et différences d'affichage écran/impression par rapport au nuancier ne constituent pas un défaut.</li>
                  <li>La garantie commerciale ne couvre <strong>ni la dépose/pose</strong>, <strong>ni les déplacements</strong>, <strong>ni les pertes d'exploitation</strong>, sauf stipulation écrite contraire.</li>
                </ul>
              </section>

              {/* Contact Info */}
              <div className="border-t border-gray-200 pt-6 mt-8">
                <p className="text-center text-gray-600">
                  <strong>Service client :</strong> {brand.contact.email} – {brand.contact.phone}<br />
                  {brand.contact.address.street}, {brand.contact.address.postalCode} {brand.contact.address.city}.
                </p>
              </div>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default GarantiePage;
